<template>
  <div>
    <attachment
      v-for="(item, index) of attachments"
      :key="index"
      :availableAttachments="availableAttachments"
      v-model="item.data"
      @remove="removeAttachment(item.seq)"
      nameWidth="200px"
    ></attachment>
    <el-button @click="addAttachment()" class="el-icon-plus">添加</el-button>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import Attachment from "../components/Attachment";

export default {
  data() {
    return {
      availableAttachments: [],
      attachments: [],
      attachmentSeq: 0,
    };
  },

  props: {
    value: null,
  },

  watch: {
    attachments: {
      handler() {
        this.$emit("updated", this.formattedAttachment);
      },
      deep: true,
    },
  },

  computed: {
    formattedAttachment() {
      let rewards = [];
      for (let e of this.attachments) {
        if (e.data.valuesOfNodes.length == 0) {
          return { errMsg: "请正确选择奖励" };
        }

        let id = e.data.valuesOfNodes[1];
        let amount = e.data.number;
        let icon = e.data.icon;
        if (amount == 0) {
          return { errMsg: "商品数量不能为0" };
        }
        rewards.push({ id: id, number: amount, icon: icon });
      }

      if (rewards.length == 0) {
        return { errMsg: "商品最少配置一项" };
      }

      return rewards;
    },
  },

  async created() {
    await this.loadAvailableAttachments();
  },
  components: {
    Attachment,
  },

  methods: {
    /**
     * 查询可用附件集合
     */
    async loadAvailableAttachments() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: false,
          },
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      for (let category of resData.data.categories) {
        this.availableAttachments.push({
          label: category.name,
          value: category.name,
          children: (() => {
            let result = [];
            for (let e of category.entries) {
              result.push({
                label: e.name,
                value: e.id,
              });
              for (let item of this.value) {
                if (item.id == e.id) {
                  this.attachments.push({
                    seq: ++this.attachmentSeq,
                    data: {
                      valuesOfNodes: [category.name, e.id],
                      number: item.number,
                      icon: item.icon,
                    },
                  });
                }
              }
            }
            return result;
          })(),
        });
      }
    },

    /**
     * 增加一个附件
     */
    addAttachment() {
      this.attachments.push({
        seq: ++this.attachmentSeq,
        data: {
          valuesOfNodes: [],
          number: 1,
        },
      });
    },

    /**
     * 删除一个附件
     */
    removeAttachment(seq) {
      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].seq == seq) {
          this.attachments.splice(i, 1);
          break;
        }
      }
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

